// @ts-nocheck
import { writable } from 'svelte/store';
import { API_URL } from '$lib/conf';
// const API_URL = 'https://seprd.lacaja.com.ar/portal_proveedores';


class Cache {
    constructor(name, entries = null, expire = 5 * 60000) {
        this.name = name;
        this.date = new Date();
        this.expire = expire;
        this.entries = entries || this.restore() || [];
        this.index = new Set()
    }

    get id() {
        return `cache__${this.name}`;
    }

    search(regex) {
        return Object.values(this.entries || {})
            .filter(({ idx }) => regex.test(idx))
            .reduce((r, { label, value }) => ({ ...r, [label]: value }), {});
    }

    restore() {
        const raw = localStorage.getItem(this.id);
        if (!raw) return {};
        const data = JSON.parse(raw);
        if (data?.expire && data.expire > Date.now()) {
            return data.data;
        }
        return {};
    }

    update(entries=[]) {
        this.entries = Object.values(
            [...this.entries, ...entries]
                .reduce((r, e) => ({...r, [e.idx + e.value]: e}), {})
        )
        localStorage.setItem(
            this.id,
            JSON.stringify({
                expire: Date.now() + this.expire,
                data: this.entries
            })
        )
    }

    get expiration() {
        return new Date(this.date.getTime() + this.expire)
    }

    get expired() {
        return Date.now() > this.expiration.getTime()
    }
}

class DynamicDict {
    constructor(path = '', { cache = null, options={}, timeCached = 3 * 60000 } = {}) {
        this.baseUrl = `${API_URL}/services/dynamicDict`.replace(/\/+$/, '');
        this.path = path.replace(/^\/+/, '');
        this.primary = cache === null;
        this.timeCached = timeCached;
        this.cache = cache || new Cache(path, [], timeCached);
        this.idx = this.primary ? '' : this.path.split('/').slice(1).join('_')//.replace(/\//g, '_');
        this.store = writable({ loading: true, data: null, error: null });
        this.options = {
            transform: options?.transform || (x => x),// Then function
            headers: options?.headers || {},
            method: options?.method || 'GET'
        }
        this.fetch().then(() => {
            this.store.update(r => ({...r, loading: false}));
        });
    }

    get url() {
        return this.path ? `${this.baseUrl}/${this.path}` : this.baseUrl;
    }

    get id() {
        return `cache__${this.path}`;
    }

    sub(pathSuffix) {
        const newPath = this.path ? `${this.path}/${pathSuffix}` : pathSuffix;
        return new DynamicDict(newPath, {
            cache: this.cache,
            timeCached: this.timeCached
        });
    }

    async fetch() {
        if (this.path?.split('/').some(x => ['undefined', 'null'].includes(x))) {return {}}
        
        // Search in cache
        const regex = new RegExp(`^${this.idx}$`, 'i');
        const cached = this.cache.search(regex)
        if(!this.cache.expired) {
            if (Object.keys(cached).length > 0) {
                this.store.set({ loading: false, data: cached, error: null })
                return cached;
            }
        }
        try {
            let data;
            this.store.set({ loading: true, data: null, error: null });
            await fetch(this.url, {method: this.options.method, headers: this.options.headers}).then(async res => {
                data = await res.json()
            });
            const entries = Object.entries(data).map(([label, value]) => ({
                idx: this.idx,
                label,
                value
            }));
            this.cache.update(entries);
            this.store.set({ loading: false, data, error: null });
            return this.options.transform(data);
        } catch (error) {
            this.store.set({ loading: false, data: cached, error });
            return cached;
        }
    }

    async get(haystack) {
        return await this.fetch().then(r => Object.entries(r)
            .find(([label, value]) => label === haystack || value === haystack))
            .then(([label, value]) => ({ label, value }))
    }

    subscribe(fn) {
        return this.store.subscribe(fn);
    }

    set(fn) {
        return this.store.set(fn)
    }

    update(fn) {
        return this.store.update(fn)
    }
}

export { Cache, DynamicDict };